import { MobileExpenseTable, WebExpenseTable } from "components";
import React from "react";
import { View } from "react-native";
import { ExpenseList, UserCollection } from "types";
import { IsWeb } from "utils";

export const ExpenseTable = ({
  tableList,
  onEditClick,
  UserCollection,
}: {
  tableList: ExpenseList[] | null;
  onEditClick: (id: string) => void;
  UserCollection: UserCollection[];
}) => {
  return (
    <>
      {tableList === null ? (
        <View></View>
      ) : IsWeb() ? (
        <WebExpenseTable
          onEditClick={onEditClick}
          tableList={tableList}
          UserCollection={UserCollection}
        />
      ) : (
        <MobileExpenseTable onEditClick={onEditClick} tableList={tableList} />
      )}
    </>
  );
};
